import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";


const userAuthContext = createContext();


export function UserAuthContextProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState("");
  
  



// Function to handle login

const login = async (email, password) => {
  try {
    const response = await fetch("https://riymay.com/api/v1/user/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });
    const data = await response.json();

    if (!response.ok) {
      // toast.error("Invalid email or password", {
      //   autoClose: 40000, // Duration in milliseconds (20 seconds).
      // });
      return { success: false, message: data.message };
    }else{
    localStorage.setItem("userToken", data.message);
    setUser({ email });
    return { success: true };
  }

  } catch (error) {
    // toast.error(error.response?.data?.message || "Login failed");
    return { success: false, message: error.message };
  }finally {
    setLoading(false);
  }
};



  // Function to handle logout
  const logout = () => {
    localStorage.removeItem("userToken");
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    // if (token) {
    
    // }
  }, [user]);


  return (
    <userAuthContext.Provider
      value={{
        setUser,
        user, 
        login,
        logout,
        loading,
        setLoading,

      
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}


export function useUserAuth() {
  return useContext(userAuthContext);
}












